import React, { forwardRef } from 'react';
import { Input, InputProps } from '@heroui/react';
import styles from './CustomInput.module.scss';

interface CustomInputProps extends Omit<InputProps, 'value'> {
  className?: string;
  isRequired?: boolean;
  label?: string;
  labelPlacement?: 'outside' | 'outside-left' | 'inside';
  placeholder?: string;
  errorMessage?: string;
  showError?: boolean;
  type?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  value?: string | null;
}

export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ className, errorMessage, showError = false, value, ...otherProps }, ref) => {
    const isInvalid = !!errorMessage;
    const classnamesInput = {
      inputWrapper: [styles.inputWrapper, className, isInvalid ? 'error' : ''],
      label: [styles.label, isInvalid ? 'error' : ''],
      errorMessage: isInvalid ? 'error' : '',
    };

    const inputProps = value !== undefined ? { ...otherProps, value: value || '' } : otherProps;

    return (
      <Input
        errorMessage={showError ? errorMessage : ''}
        isInvalid={isInvalid}
        ref={ref}
        classNames={classnamesInput}
        variant="bordered"
        radius="sm"
        {...inputProps}
      />
    );
  },
);

CustomInput.displayName = 'CustomInput';
